@if (selectedTab) {
  <p-tabs scrollable [value]="selectedTab.value">
    <p-tablist>
      @for (tab of tabList; track $index) {
        <p-tab [value]="tab.value" [disabled]="tab.disabled" (click)="changeTab(tab)">
          <div class="flex w-100 items-center justify-center gap-1.5 text-center">
            <span>{{ tab.name | translate }}</span>
            @if (tab.count !== undefined) {
              <span
                class="inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full px-1.5 text-xs font-semibold"
                [ngClass]="tab.value === selectedTab.value ? 'bg-[var(--primary-color)]/10 text-[var(--primary-color)]' : 'bg-slate-100 text-slate-400'"
              >{{ tab.count }}</span>
            }
          </div>
        </p-tab>
      }
    </p-tablist>
  </p-tabs>
}
